import React from "react";

export default function ErrorBoundary() {
  window.location.replace('#/chatrooms')
  return <></>;
}
